import React from 'react';

export default () => {
  return (
    <div>
      <section class="banner_area">
        <div class="banner_inner d-flex align-items-center">
          <div class="container">
            <div class="banner_content text-center">
				      <div class="d-flex justify-content-center align-items-end">
                <h2 class="store-name">Loja do Igor</h2>
                <img class="store-icon" src={require('../img/gift/voucher-icon.png')} />
              </div>
              <div class="page_link">
                <a href="#">Início</a>
                <a href="#">Loja do Igor</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="product_image_area">
      	<div class="container">
      		<div class="row s_product_inner">
      			<div class="col-lg-6">
              <div class="product_img_background">
                <div class="s_product_img">
                  <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel">
                    <ol class="carousel-indicators">
                      <li data-target="#carouselExampleIndicators" data-slide-to="0" class="active">
                        <img src={require('../img/product/single-product/s-product-s-2.jpg')} alt="" />
                      </li>
                      <li data-target="#carouselExampleIndicators" data-slide-to="1">
                        <img src={require('../img/product/single-product/s-product-s-3.jpg')} alt="" />
                      </li>
                      <li data-target="#carouselExampleIndicators" data-slide-to="2">
                        <img src={require('../img/product/single-product/s-product-s-4.jpg')} alt="" />
                      </li>
                    </ol>
                    <div class="carousel-inner">
                      <div class="carousel-item active">
                        <img class="d-block" src={require('../img/product/single-product/s-product-1.jpg')} alt="First slide" />
                      </div>
                      <div class="carousel-item">
                        <img class="d-block" src={require('../img/product/single-product/s-product-1.jpg')} alt="Second slide" />
                      </div>
                      <div class="carousel-item">
                        <img class="d-block" src={require('../img/product/single-product/s-product-1.jpg')} alt="Third slide" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
      			</div>
      			<div class="col-lg-5 offset-lg-1">
      				<div class="s_product_text">
      					<h3>Voucher beneficente</h3>
      					<h2>R$ 149,99</h2>
      					<ul class="list">
      						<li class="d-flex flex-direction-row align-items-end"><span>Em produtos:</span> <h2 class="gift_value">R$ 170</h2></li>
      					</ul>
      					<p><strong>Este é um voucher para ajudar a loja do igor a passar por essa crise.</strong><br /><br />Você compra esse voucher por R$149,99 agora, e após a quarentena ele valerá  R$170 em produtos da loja.</p>
      					<div class="card_area">
                  <a class="green_btn" href="https://www.mercadopago.com.br/checkout/v1/redirect?pref_id=542329789-3c0ba017-8200-4506-a4dc-f80f40c70203" target="_blank">
                    Adquirir voucher agora
                  </a>
      					</div>
      				</div>
      			</div>
      		</div>
      	</div>
      </section>

      <section class="product_description_area">
        <div class="container">
				  <ul class="nav nav-tabs" id="myTab" role="tablist">
				  	<li class="nav-item">
				  	  <a class="nav-link" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">Como estou ajudando a loja?</a>
				  	</li>
				  	<li class="nav-item">
				  	  <a class="nav-link" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Como usar o voucher?</a>
				  	</li>
            {/*
				  	<li class="nav-item">
				  	  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#contact" role="tab" aria-controls="contact" aria-selected="false">Comments</a>
				  	</li>
				  	<li class="nav-item">
				  	  <a class="nav-link active" id="review-tab" data-toggle="tab" href="#review" role="tab" aria-controls="review" aria-selected="false">Reviews</a>
            </li>
            */}
				  </ul>
				  <div class="tab-content" id="myTabContent">
					  <div class="tab-pane fade" id="home" role="tabpanel" aria-labelledby="home-tab">
              <div>
                <p class="text-center"><strong>Você está prestes a ajudar um microempreendedor a passar pela crise</strong></p>

                <p class="text-center">O Covid-19 traz vários desafios para pequenos empreendedores. Principalmente aqueles 
                <br />que dependem de portas abertas para faturar. Pois a empresa gera custos e sem o faturamento 
                <br />não dá pra pagar. Comprando esse voucher você adianta o faturamento para o empreendedor, 
                <br />mantendo a empresa viva e ao mesmo tempo ganha um super desconto
                <br />para usar daqui a pouco ;)</p>
              </div>
					  </div>
					  <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
              <p class="text-center">Assim que a situação se normalizar em relação ao Covid-19 e o empreendimento voltar 
              <br />a funcionar você será notificado(a) por email. Depois é só apresentar o Voucher no caixa, em caso 
              <br />de estabelecimentos físicos. Ou combinar a entrega do produto com o empreendedor(ra).</p>

              <p class="text-center">Em caso de dúvidas mande um email para:
              <br /><strong>contato.cogift@gmail.com</strong></p>
					  </div>
            {/*
					  <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
						  <div class="row">
						  	<div class="col-lg-6">
						  		<div class="comment_list">
						  			<div class="review_item">
						  				<div class="media">
						  					<div class="d-flex">
						  						<img src="img/product/single-product/review-1.png" alt="" />
						  					</div>
						  					<div class="media-body">
						  						<h4>Blake Ruiz</h4>
						  						<h5>12th Feb, 2017 at 05:56 pm</h5>
						  						<a class="reply_btn" href="#">Reply</a>
						  					</div>
						  				</div>
						  				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
						  			</div>
						  			<div class="review_item reply">
						  				<div class="media">
						  					<div class="d-flex">
						  						<img src="img/product/single-product/review-2.png" alt="" />
						  					</div>
						  					<div class="media-body">
						  						<h4>Blake Ruiz</h4>
						  						<h5>12th Feb, 2017 at 05:56 pm</h5>
						  						<a class="reply_btn" href="#">Reply</a>
						  					</div>
						  				</div>
						  				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
						  			</div>
						  			<div class="review_item">
						  				<div class="media">
						  					<div class="d-flex">
						  						<img src="img/product/single-product/review-3.png" alt="" />
						  					</div>
						  					<div class="media-body">
						  						<h4>Blake Ruiz</h4>
						  						<h5>12th Feb, 2017 at 05:56 pm</h5>
						  						<a class="reply_btn" href="#">Reply</a>
						  					</div>
						  				</div>
						  				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
						  			</div>
						  		</div>
						  	</div>
						  	<div class="col-lg-6">
						  		<div class="review_box">
						  			<h4>Post a comment</h4>
						  			<form class="row contact_form" action="contact_process.php" method="post" id="contactForm" novalidate="novalidate">
						  				<div class="col-md-12">
						  					<div class="form-group">
						  						<input type="text" class="form-control" id="name" name="name" placeholder="Your Full name" />
						  					</div>
						  				</div>
						  				<div class="col-md-12">
						  					<div class="form-group">
						  						<input type="email" class="form-control" id="email" name="email" placeholder="Email Address" />
						  					</div>
						  				</div>
						  				<div class="col-md-12">
						  					<div class="form-group">
						  						<input type="text" class="form-control" id="number" name="number" placeholder="Phone Number" />
						  					</div>
						  				</div>
						  				<div class="col-md-12">
						  					<div class="form-group">
						  						<textarea class="form-control" name="message" id="message" rows="1" placeholder="Message"></textarea>
						  					</div>
						  				</div>
						  				<div class="col-md-12 text-right">
						  					<button type="submit" value="submit" class="btn submit_btn">Submit Now</button>
						  				</div>
						  			</form>
						  		</div>
						  	</div>
						  </div>
					  </div>
					  <div class="tab-pane fade show active" id="review" role="tabpanel" aria-labelledby="review-tab">
						  <div class="row">
							  <div class="col-lg-6">
							  	<div class="row total_rate">
							  		<div class="col-6">
							  			<div class="box_total">
							  				<h5>Overall</h5>
							  				<h4>4.0</h4>
							  				<h6>(03 Reviews)</h6>
							  			</div>
							  		</div>
							  		<div class="col-6">
							  			<div class="rating_list">
							  				<h3>Based on 3 Reviews</h3>
							  				<ul class="list">
							  					<li><a href="#">5 Star <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i> 01</a></li>
							  					<li><a href="#">4 Star <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i> 01</a></li>
							  					<li><a href="#">3 Star <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i> 01</a></li>
							  					<li><a href="#">2 Star <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i> 01</a></li>
							  					<li><a href="#">1 Star <i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i> 01</a></li>
							  				</ul>
							  			</div>
							  		</div>
							  	</div>
							  	<div class="review_list">
							  		<div class="review_item">
							  			<div class="media">
							  				<div class="d-flex">
							  					<img src="img/product/single-product/review-1.png" alt="" />
							  				</div>
							  				<div class="media-body">
							  					<h4>Blake Ruiz</h4>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  				</div>
							  			</div>
							  			<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
							  		</div>
							  		<div class="review_item">
							  			<div class="media">
							  				<div class="d-flex">
							  					<img src="img/product/single-product/review-2.png" alt="" />
							  				</div>
							  				<div class="media-body">
							  					<h4>Blake Ruiz</h4>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  				</div>
							  			</div>
							  			<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
							  		</div>
							  		<div class="review_item">
							  			<div class="media">
							  				<div class="d-flex">
							  					<img src="img/product/single-product/review-3.png" alt="" />
							  				</div>
							  				<div class="media-body">
							  					<h4>Blake Ruiz</h4>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  					<i class="fa fa-star"></i>
							  				</div>
							  			</div>
							  			<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo</p>
							  		</div>
							  	</div>
							  </div>
							  <div class="col-lg-6">
								  <div class="review_box">
									  <h4>Add a Review</h4>
									  <p>Your Rating:</p>
									  <ul class="list">
									  	<li><a href="#"><i class="fa fa-star"></i></a></li>
									  	<li><a href="#"><i class="fa fa-star"></i></a></li>
									  	<li><a href="#"><i class="fa fa-star"></i></a></li>
									  	<li><a href="#"><i class="fa fa-star"></i></a></li>
									  	<li><a href="#"><i class="fa fa-star"></i></a></li>
									  </ul>
									  <p>Outstanding</p>
									  <form class="row contact_form" action="contact_process.php" method="post" id="contactForm" novalidate="novalidate">
										  <div class="col-md-12">
										  	<div class="form-group">
										  		<input type="text" class="form-control" id="name" name="name" placeholder="Your Full name" />
										  	</div>
										  </div>
										  <div class="col-md-12">
										  	<div class="form-group">
										  		<input type="email" class="form-control" id="email" name="email" placeholder="Email Address" />
										  	</div>
										  </div>
										  <div class="col-md-12">
										  	<div class="form-group">
										  		<input type="text" class="form-control" id="number" name="number" placeholder="Phone Number" />
										  	</div>
										  </div>
										  <div class="col-md-12">
										  	<div class="form-group">
										  		<textarea class="form-control" name="message" id="message" rows="1" placeholder="Review"></textarea>
										  	</div>
										  </div>
										  <div class="col-md-12 text-right">
										  	<button type="submit" value="submit" class="btn submit_btn">Enviar</button>
										  </div>
									  </form>
								  </div>
							  </div>
						  </div>
            </div>
            */}
				  </div>
        </div>
      </section>
    </div>
  );
};
